import { Grid, Box } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormTextField from '../../../FormFields/FormTextField';
import FormTitle from '../../../FormFields/FormTitle';
import FormFileDrop from '../../../FormFields/FormFileDrop';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { groupedFieldsStyle } from '../../../TransitionStyles';

PhysicianSection.propTypes = {
  isEditable: PropTypes.bool,
  fieldName: PropTypes.string,
  showTitleQuestion: PropTypes.bool,
};

export default function PhysicianSection({ isEditable, fieldName, showTitleQuestion = false }) {
  const [focusedField, setFocusedField] = useState(null);

  return (
    <>
      <Grid container item xs={12} wrap="nowrap" alignItems="center" sx={{ mb: 1 }}>
        <Grid item xs={12}>
          <Box sx={{ backgroundColor: '#f1f3f4cc', ...groupedFieldsStyle }}>
            <Grid container spacing={1.5}>
              {showTitleQuestion && (
                <Grid item xs={12} md={4}>
                  <FieldContainer>
                    <FormTitle fieldAttributes={{ questionTitle: 'Title' }} />
                    <FormTextField
                      fieldName={`${fieldName}.title`}
                      focusedField={focusedField}
                      setFocusedField={setFocusedField}
                      fieldAttributes={{ isEditable }}
                    />
                  </FieldContainer>
                </Grid>
              )}
              <Grid item xs={12} md={showTitleQuestion ? 4 : 6}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'First name' }} />
                  <FormTextField
                    fieldName={`${fieldName}.firstName`}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                    fieldAttributes={{ isEditable }}
                  />
                </FieldContainer>
              </Grid>
              <Grid item xs={12} md={showTitleQuestion ? 4 : 6}>
                <FormTitle fieldAttributes={{ questionTitle: 'Last name' }} />
                <FormTextField
                  fieldName={`${fieldName}.lastName`}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                  fieldAttributes={{ isEditable }}
                />
              </Grid>
              <Grid item xs={12}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Upload contract', fieldType: 'file' }} />
                  <FormFileDrop
                    fieldName={`${fieldName}.contracts`}
                    fieldAttributes={{
                      isEditable,
                      fileTypeId: FILE_TYPES.PHYSICIAN_CONTRACT,
                    }}
                  />
                </FieldContainer>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
